<ng-container *ngIf="addOnImagePassOn">
	<span class="add_on_image_wrapper">
		<span class="pos_abs_span" id="img_jump_to_fabric" ></span>
		<img src="{{addOnImagePassOn}}" id="img_{{imageGallery.length}}" />
	</span>
</ng-container>
<ng-container *ngFor="let image of imageGallery; let i = index">
	<ng-container *ngIf="!image.image.includes('youtu')">
		<bmx-zoomify id="img_{{i}}"
							[src]="{
							 url: image.image,
							 altText: image.altText
							}"
							class="image_container hover:cursor-crosshair">
		</bmx-zoomify>
	</ng-container>
	<ng-container *ngIf="image.image.includes('youtu')">
		<div class="videocont">
			<iframe width="315"
					height="560"
					id="img_{{i}}"
					[src]="safeURL"
					title="YouTube video player"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
					allowfullscreen></iframe>
		</div>
	</ng-container>
</ng-container>
